import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Skeleton,
  Typography,
} from '@mui/material';
import React from 'react';

export const Popup = ({
  open,
  handleClose,
  isLoading,
  dialogText,
  setDialogText,
}) => {
  function copyText() {
    const reviewContent = document.getElementById('review-content');
    if (reviewContent) {
      const textToCopy = reviewContent.innerText || reviewContent.textContent;

      // Use the Clipboard API to copy text to the clipboard
      navigator.clipboard
        .writeText(textToCopy)
        .then(function () {
          setDialogText('Text copied to clipboard!');
        })
        .catch(function (err) {
          console.error('Unable to copy text: ', err);
        });
    } else {
      console.error('Element with id "review-content" not found.');
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>{`${isLoading ? 'Generating' : 'Generated'} Review`}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {isLoading ? (
            <>
              <Skeleton width={'100%'} variant={'text'}></Skeleton>
              <Skeleton width={'100%'} variant={'text'}></Skeleton>
              <Skeleton width={'100%'} variant={'text'}></Skeleton>
              <Skeleton width={'100%'} variant={'text'}></Skeleton>
              <Skeleton width={'100%'} variant={'text'}></Skeleton>
            </>
          ) : (
            <Typography id="review-content">{dialogText}</Typography>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant={'text'} disabled={isLoading} onClick={handleClose}>
          Close
        </Button>
        <Button
          variant={'contained'}
          disabled={isLoading}
          onClick={copyText}
          autoFocus
        >
          Copy Review
        </Button>
      </DialogActions>
    </Dialog>
  );
};
